import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link as MuiLink,
  Divider,
} from '@mui/material';
import {
  BalanceOutlined as ScaleIcon,
  CheckCircleOutlined as CircleCheckIcon,
  DescriptionOutlined as FileTextIcon,
  SupportAgentOutlined as SupportIcon,
  ShieldOutlined as ShieldIcon,
} from '@mui/icons-material';

// Cores base para o tema da FazPedido
const PRIMARY_COLOR = '#7C3AED';
const HOVER_COLOR = '#5B21B6';
const BG_HEADER_ICON = '#EDE9FE';
const BG_CARD_BORDER = '#E4DEFF';
const TEXT_DARK = '#1E1B4B';
const TEXT_MUTED = '#4B4A6C';

export default function FazPedidoTermsOfService() {
  const allSections = [
    {
      title: '1. Definições',
      content:
        'Define os termos fundamentais da plataforma: FazPedido (plataforma tecnológica da FAZPEDIDO SERVIÇOS DE TECNOLOGIA LTDA), Lojista (contratante para criação de catálogo/cardápio e gestão de pedidos), Consumidor (usuário final do catálogo/pedido), Plataforma (sistemas, APIs, painéis, aplicativos e bases de dados) e Conteúdo (textos, imagens, preços, marcas e materiais inseridos).',
    },
    {
      title: '2. Natureza do Serviço',
      content:
        'A FazPedido fornece infraestrutura tecnológica e software como serviço (SaaS). Salvo contratação expressa, a FazPedido não atua como fabricante, fornecedora, proprietária de estoque, responsável por preparo, entrega, estabelecimento, preços, promoções, emissão fiscal, representação comercial ou empregadora dos funcionários/entregadores do Lojista. A utilização não cria sociedade ou vínculo empregatício.',
    },
    {
      title: '3. Relação entre Lojista e Consumidor',
      content:
        'O Lojista é exclusivamente responsável pela relação comercial com seus Consumidores (disponibilizar produtos, estoque, preços, cumprimento de ofertas, preparo, informações verdadeiras, normas sanitárias, entrega, emissão fiscal, atendimento, trocas, cancelamentos, reembolsos e reclamações). Nada afasta responsabilidades atribuídas diretamente à Fazido por lei.',
    },
    {
      title: '4. Responsabilidades do Lojista',
      content:
        'O Lojista garante a veracidade e atualização de seus dados cadastrais, proteção de credenciais, controle de usuários autorizados, atualização de preços, posse de autorizações/direitos sobre produtos e marcas, e estrito cumprimento das legislações aplicáveis (tributária, consumerista, sanitária, proteção de dados e direitos autorais).',
    },
    {
      title: '5. Conteúdo Publicado pelo Lojista',
      content:
        'O Lojista é o único responsável por fotografias, vídeos, textos, preços, promoções, marcas, informações nutricionais, prazos e entregas. A FazPedido poderá remover, limitar ou suspender conteúdos por indícios de ilegalidade, fraude, violação de direitos, conteúdo enganoso, risco à segurança ou ordem de autoridade.',
    },
    {
      title: '6. Licença sobre o Conteúdo',
      content:
        'O Lojista concede à FazPedido licença gratuita, não exclusiva e limitada ao período necessário para hospedar, armazenar, processar, reproduzir, adaptar e exibir conteúdos estritamente para o funcionamento da plataforma, cardápios, pedidos, backups, segurança e divulgação nas funcionalidades contratadas. O Lojista permanece titular de seus direitos.',
    },
    {
      title: '7. Conta, Usuários e Segurança',
      content:
        'Exige dados verdadeiros e sigilo de senhas. O Lojista responde por atividades de usuários autorizados e deve comunicar imediatamente suspeitas de invasão, vazamento ou fraude. A FazPedido pode adotar medidas preventivas de segurança, como bloqueios temporários.',
    },
    {
      title: '8. Usos Proibidos',
      content:
        'Veda expressamente a prática de crimes, fraudes, lavagem de dinheiro, spam, phishing, malware, invasão, engenharia reversa, coleta automatizada abusiva, violação de direitos autorais/marcas, conteúdo ilegal/discriminatório e comercialização de produtos proibidos por lei.',
    },
    {
      title: '9. Planos e Assinaturas',
      content:
        'Disponibilização de planos gratuitos ou pagos (mensal, anual ou outra periodicidade informada). Preços e funcionalidades são apresentados previamente. A FazPedido poderá alterar preços futuros mediante comunicação adequada, respeitando períodos já pagos.',
    },
    {
      title: '10. Inadimplência',
      content:
        'Em caso de não pagamento, a FazPedido poderá restringir funcionalidades, suspender recursos premium, impedir novas operações, suspender o acesso temporariamente, cobrar valores devidos ou encerrar a conta após período razoável.',
    },
    {
      title: '11. Cancelamento',
      content:
        'O Lojista pode solicitar o cancelamento pelos canais disponibilizados, interrompendo cobranças futuras. Valores de períodos já iniciados ou utilizados não são automaticamente reembolsados, salvo direitos legais ou regras específicas.',
    },
    {
      title: '12. Pagamentos de Pedidos',
      content:
        'Integrações com meios de pagamento dependem de instituições financeiras, adquirentes ou gateways. A FazPedido não garante aprovação de transações, disponibilidade permanente de meios específicos, ausência de chargebacks/estornos ou operação ininterrupta de terceiros.',
    },
    {
      title: '13. Integrações e Serviços de Terceiros',
      content:
        'A plataforma pode integrar-se com WhatsApp, hospedagem, provedores de pagamento, mapas, e-mails e APIs de terceiros. Estes serviços possuem regras próprias e indisponibilidades independentes da FazPedido, que poderá substituir ou descontinuar integrações em caso de falhas de terceiros.',
    },
    {
      title: '14. WhatsApp e Comunicações',
      content:
        'Ferramentas de comunicação entre Lojista e Consumidor exigem respeito à privacidade, proteção de dados, publicidade e regras contra spam. A FazPedido pode restringir comunicações diante de abusos, denúncias ou violações de políticas dos provedores.',
    },
    {
      title: '15. Entrega',
      content:
        'Salvo contratação expressa de serviço próprio da FazPedido, a entrega é responsabilidade do Lojista ou de terceiros por ele contratados. A FazPedido não garante prazos, disponibilidade de entregadores, integridade de produtos, temperatura ou conduta de transporte.',
    },
    {
      title: '16. Disponibilidade da Plataforma',
      content:
        'A FazPedido emprega esforços razoáveis para manter a plataforma ativa, mas reconhece que manutenções, atualizações, falhas de rede, ataques cibernéticos ou eventos de força maior podem causar interrupções temporárias.',
    },
    {
      title: '17. Limitação de Responsabilidade',
      content:
        'Na máxima extensão permitida em lei, a FazPedido não responde por atos de lojistas, consumidores ou terceiros (produtos defeituosos, contaminação, erros de preço, atrasos de entrega, tributos, obrigações sanitárias ou condutas de entregadores/funcionários), nem por lucros cessantes.',
    },
    {
      title: '18. Limite de Responsabilidade Contratual',
      content:
        'Eventual responsabilidade contratual direta da FazPedido decorrente exclusivamente da plataforma fica limitada ao montante efetivamente pago pelo Lojista à FazPedido nos 12 meses anteriores ao evento gerador.',
    },
    {
      title: '19. Indenização e Direito de Regresso',
      content:
        'O Lojista obriga-se a ressarcir a FazPedido por prejuízos decorrentes de atos do próprio Lojista em violação aos Termos ou à lei (conteúdo publicado, propriedade intelectual, dados pessoais, fraude ou spam), sem transferir responsabilidades legais próprias da plataforma.',
    },
    {
      title: '20. Proteção de Dados',
      content:
        'Sujeito à Política de Privacidade da FazPedido. Atua tipicamente como Operadora quando trata dados em nome do Lojista (Controlador) para execução dos serviços, e como Controladora em tratamentos próprios e independentes. O Lojista deve cumprir integralmente a LGPD.',
    },
    {
      title: '21. Segurança e Incidentes',
      content:
        'A FazPedido adota medidas técnicas e administrativas razoáveis de proteção, embora nenhum sistema conectado à internet seja imune a falhas. Em incidentes, adotará medidas cabíveis, devendo o Lojista comunicar imediatamente qualquer comprometimento de conta.',
    },
    {
      title: '22. Propriedade Intelectual da FazPedido',
      content:
        'Software, código, arquitetura, interface, marcas e APIs pertencem exclusivamente à FazPedido. O acesso concede apenas licença limitada, revogável e não exclusiva durante a vigência do contrato, sem transferência de direitos proprietários.',
    },
    {
      title: '23. Suspensão e Encerramento da Conta',
      content:
        'Contas poderão ser suspensas ou encerradas por violação dos Termos, fraude, ilícitos, risco de segurança, inadimplência, spam, uso abusivo ou ordem de autoridade, sem eliminar obrigações financeiras já constituídas.',
    },
    {
      title: '24. Preservação de Registros',
      content:
        'A FazPedido poderá reter logs, registros técnicos e informações de acesso para fins de segurança, prevenção de fraudes, investigações de incidentes, cumprimento de obrigações legais, ordens judiciais e exercício regular de direitos.',
    },
    {
      title: '25. Alterações da Plataforma',
      content:
        'A FazPedido poderá modificar, atualizar ou remover funcionalidades por razões técnicas, comerciais, legais ou de segurança, comunicando os usuários quando houver impacto substancial.',
    },
    {
      title: '26. Alterações destes Termos',
      content:
        'Os Termos podem ser atualizados para refletir mudanças legais, tecnológicas ou comerciais. Alterações materiais serão comunicadas por e-mail ou painel administrativo, e a continuidade do uso representará aceitação.',
    },
    {
      title: '27. Comunicações',
      content:
        'O Lojista autoriza contatos por dados cadastrados sobre pagamentos, segurança, suporte e termos. É dever do Lojista mantê-los atualizados; comunicações enviadas para esses endereços serão consideradas válidas.',
    },
    {
      title: '28. Não Renúncia',
      content:
        'A ausência de exercício imediato de direitos pela FazPedido não configura renúncia, novação ou perda de tal direito.',
    },
    {
      title: '29. Nulidade Parcial',
      content:
        'Caso alguma disposição seja considerada inválida, as demais permanecerão em pleno vigor, buscando-se preservar a finalidade econômica e jurídica original.',
    },
    {
      title: '30. Legislação Aplicável',
      content:
        'Estes Termos são regidos pelas leis da República Federativa do Brasil, observando-se obrigatoriamente as normas de proteção ao consumidor quando aplicável.',
    },
    {
      title: '31. Foro',
      content:
        'Fica eleito o foro da Comarca de São Paulo/SP para relações empresariais e contratuais, sem prejuízo das regras de competência territorial de aplicação obrigatória e indisponível.',
    },
    {
      title: '32. Aceite Eletrônico',
      content:
        'O aceite ocorre por marcação de caixa, botão de confirmação, criação de conta, contratação de plano ou utilização continuada, servindo como comprovação válida de concordância.',
    },
    {
      title: '33. Canais Oficiais',
      content:
        'FAZPEDIDO SERVIÇOS DE TECNOLOGIA LTDA. Suporte: suporte@fazpedido.com.br · Jurídico e LGPD: juridico@fazpedido.com.br · WhatsApp: (11) 9 81799-101 (segunda a sexta, das 09h às 18h).',
    },
  ];

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#FAF9FF' }}>
      {/* Header Section */}
      <Box
        component="header"
        sx={{
          borderBottom: `1px solid ${BG_CARD_BORDER}`,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(8px)',
          py: { xs: 6, sm: 8 },
          px: 3,
          textAlign: 'center',
        }}
      >
        <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              backgroundColor: BG_HEADER_ICON,
              color: PRIMARY_COLOR,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <ScaleIcon sx={{ fontSize: 32 }} />
          </Box>

          <Typography
            variant="h3"
            component="h1"
            sx={{ fontWeight: 'bold', color: TEXT_DARK, fontSize: { xs: '1.875rem', sm: '2.25rem' } }}
          >
            Termos de Uso da FazPedido
          </Typography>

          <Typography variant="body1" sx={{ color: TEXT_MUTED, maxWidth: '700px', lineHeight: 1.6 }}>
            Estes Termos regulam o acesso e a utilização da plataforma FazPedido, disponibilizada por <strong>FAZPEDIDO SERVIÇOS DE TECNOLOGIA LTDA</strong>.
          </Typography>

          <Typography variant="caption" sx={{ color: PRIMARY_COLOR, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>
            Última atualização: 04 de setembro de 2026
          </Typography>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center', mt: 1 }}>
            <Button
              variant="contained"
              href="mailto:suporte@fazpedido.com.br"
              sx={{
                borderRadius: '50px',
                backgroundColor: PRIMARY_COLOR,
                color: '#fff',
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                boxShadow: '0 4px 12px rgba(124, 58, 237, 0.2)',
                '&:hover': {
                  backgroundColor: HOVER_COLOR,
                },
              }}
            >
              Fale com o suporte
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Main Content Area */}
      <Container component="main" maxWidth="md" sx={{ py: 6, display: 'flex', flexDirection: 'column', gap: 4 }}>

        {/* Aviso de Introdução */}
        <Card variant="outlined" sx={{ borderRadius: 4, borderColor: BG_CARD_BORDER, backgroundColor: 'rgba(255,255,255,0.95)' }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="body2" sx={{ color: TEXT_MUTED, lineHeight: 1.6 }}>
              Ao criar uma conta, contratar um plano, acessar o painel administrativo, cadastrar produtos ou utilizar qualquer funcionalidade da FazPedido, o Lojista declara que leu, compreendeu e concorda com estes Termos. Caso não concorde com qualquer disposição, deverá interromper a utilização da plataforma.
            </Typography>
          </CardContent>
        </Card>

        {/* Todas as 33 Seções */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {allSections.map((section, index) => (
            <Card key={index} variant="outlined" sx={{ borderRadius: 4, borderColor: BG_CARD_BORDER, backgroundColor: 'rgba(255,255,255,0.95)' }}>
              <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                <FileTextIcon sx={{ color: PRIMARY_COLOR }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: TEXT_DARK, fontSize: '1.1rem' }}>
                  {section.title}
                </Typography>
              </Box>
              <CardContent sx={{ pt: 0 }}>
                <Typography variant="body2" sx={{ color: TEXT_MUTED, lineHeight: 1.6 }}>
                  {section.content}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

        {/* Canais Oficiais e Suporte */}
        <Card variant="outlined" sx={{ borderRadius: 4, borderColor: BG_CARD_BORDER, backgroundColor: 'rgba(255,255,255,0.95)' }}>
          <Box sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
            <SupportIcon sx={{ color: PRIMARY_COLOR }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: TEXT_DARK }}>
              33. Canais Oficiais e Atendimento
            </Typography>
          </Box>
          <CardContent sx={{ pt: 0, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Typography variant="body2" sx={{ color: TEXT_MUTED }}>
              FAZPEDIDO SERVIÇOS DE TECNOLOGIA LTDA. Para dúvidas jurídicas, suporte técnico ou LGPD, utilize os canais abaixo:
            </Typography>
            <List disablePadding>
              <ListItem disableGutters sx={{ alignItems: 'center', py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <ShieldIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />
                </ListItemIcon>
                <Typography variant="body2" sx={{ color: TEXT_MUTED }}>
                  Suporte Técnico:{' '}
                  <MuiLink href="mailto:suporte@fazpedido.com.br" underline="always" sx={{ color: PRIMARY_COLOR, fontWeight: 600 }}>
                    suporte@fazpedido.com.br
                  </MuiLink>
                </Typography>
              </ListItem>

              <ListItem disableGutters sx={{ alignItems: 'center', py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <ShieldIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />
                </ListItemIcon>
                <Typography variant="body2" sx={{ color: TEXT_MUTED }}>
                  Jurídico e LGPD:{' '}
                  <MuiLink href="mailto:juridico@fazpedido.com.br" underline="always" sx={{ color: PRIMARY_COLOR, fontWeight: 600 }}>
                    juridico@fazpedido.com.br
                  </MuiLink>
                </Typography>
              </ListItem>

              <ListItem disableGutters sx={{ alignItems: 'center', py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <SupportIcon fontSize="small" sx={{ color: PRIMARY_COLOR }} />
                </ListItemIcon>
                <Typography variant="body2" sx={{ color: TEXT_MUTED }}>
                  WhatsApp: (11) 9 81799-101 · Segunda a sexta-feira, das 09h às 18h, horário de Brasília.
                </Typography>
              </ListItem>
            </List>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}